import styles from "./notificationcard.module.css";
import { Edit, Eye, EyeOff, MoreVertical } from "react-feather";
import { Dropdown } from "react-bootstrap";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";

const NotificationCard = ({ item, setArchiveModalOpen, setPublishModalOpen, setSelectedItem }) => {
    const history = useHistory();

    return (<div className={`${styles.ProspectCard}`}>
        <div className={`${styles.ProspectCardUnder}`} style={{ cursor: 'pointer' }} onClick={() => { history.push('/notification/email-sms-notification/view/' + item?.id) }}>
            <div className={`${styles.ProspectCardHeadSection}`}>
                <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => e.stopPropagation()}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => { history.push('/notification/email-sms-notification/view/' + item?.id) }}>
                            <Eye /> Preview
                        </Dropdown.Item>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => { history.push('/notification/email-sms-notification/edit/' + item?.id) }}>
                            <Edit /> Edit
                        </Dropdown.Item>
                        {item?.is_archived === 0 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setArchiveModalOpen(true); setSelectedItem(item); }}>
                            <EyeOff /> Unpublished
                        </Dropdown.Item>}
                        {item?.is_archived === 1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setPublishModalOpen(true); setSelectedItem(item); }}>
                            <Eye /> Published
                        </Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
                <div className={`${styles.ProsIMGSec}`}>
                    {item?.type === 'SMS' ? <img src="/static/img/sms-notification.svg" alt="" /> : <img src="/static/img/email-template.svg" alt="" />}
                </div>
                <div className={`${styles.HeadConSec}`}>
                    <p className={`${styles.ProsUserName}`}>
                        <span className={`${styles.UserName}`}>{item?.category}</span>
                    </p>
                </div>
            </div>
            <div className={`${styles.ProspectCardFootSec}`}>
                <p className={`${styles.LeaseConDate}`}>{dayjs(item?.created_at).fromNow()}</p>
                <span className={`${styles.PublishBadge}`}>{item?.is_archived === 0 ? "Published" : "Unpublished"}</span>
            </div>
        </div>
    </div>)
}

export default NotificationCard;